import {axiosService} from "../axios.service";
import {urls} from "../../constants";


const  menuCategoriesService = {
    getAll: () => axiosService.get(urls.settings.category).then(value => value.data),
    createCategory: (data) => axiosService.post(urls.settings.category, data).then((value) => value.data),
    getCategoryById: (id) => axiosService.get(`${urls.settings.category}/${id}`).then(value => value.data),
    updateById: (id, data) => axiosService.patch(`${urls.settings.category }/${id}`, data).then((value) => value.data),
    deleteById: (id) => axiosService.destroy(`${urls.settings.category}/${id}`),
}

export {
    menuCategoriesService
}